// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-portrait .img[style*="width"],
.navbar-portrait .img[style*="height"] {
  width: unset;
  height: unset;
}
.applicants-widget .item .recruitment-flow {
  overflow: hidden;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/ProfileImage/index.less"],"names":[],"mappings":"AAAA;;EAEI,YAAA;EACA,aAAA;ACCJ;ADEA;EACI,gBAAA;ACAJ;AACA,oCAAoC","sourcesContent":[".navbar-portrait .img[style*=\"width\"],\n.navbar-portrait .img[style*=\"height\"] {\n    width: unset;\n    height: unset;\n}\n\n.applicants-widget .item .recruitment-flow {\n    overflow: hidden;\n} ",".navbar-portrait .img[style*=\"width\"],\n.navbar-portrait .img[style*=\"height\"] {\n  width: unset;\n  height: unset;\n}\n.applicants-widget .item .recruitment-flow {\n  overflow: hidden;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
